import React, { useState } from 'react';
import { Box, Container, Typography, Button, Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import ReversalUploadCard from '../components/ReversalUploadCard';
import { downloadReversalSampleExcel } from '../utils/reversalSampleGenerator';
interface TransactionReversalProps {
  onLogout: () => void;
}
const TransactionReversal: React.FC<TransactionReversalProps> = ({
  onLogout
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUploadCard, setShowUploadCard] = useState(false);
  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-5066">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} activePage="transaction-reversal" data-id="element-5067" />
      <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-5068">
        <TopBar onMenuClick={handleToggleSidebar} onLogout={onLogout} title="Transaction Reversal" data-id="element-5069" />
        <Container maxWidth="xl" sx={{
        mt: 4,
        mb: 4,
        flex: 1
      }} data-id="element-5070">
          {!showUploadCard ? <Card elevation={0} sx={{
          borderRadius: 2,
          border: '1px solid #E5E7EB',
          textAlign: 'center',
          py: 8
        }} data-id="element-5071">
              <CardContent data-id="element-5072">
                <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)',
              mb: 3
            }} data-id="element-5073">
                  <Icon icon="lucide:undo-2" width={40} height={40} color="#EF4444" data-id="element-5074" />
                </Box>
                <Typography variant="h5" gutterBottom fontWeight={600} data-id="element-5075">
                  Reverse Posted Transactions
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{
              mb: 4,
              maxWidth: 600,
              mx: 'auto'
            }} data-id="element-5076">
                  Upload a file containing transaction details to reverse
                  already posted transactions. The system will validate the
                  data, match it against existing transactions, and process
                  reversals.
                </Typography>
                <Box sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap'
            }} data-id="element-5077">
                  <Button variant="outlined" startIcon={<Icon icon="lucide:download" width={18} data-id="element-5079" />} onClick={downloadReversalSampleExcel} sx={{
                borderColor: '#E5E7EB',
                color: 'text.primary',
                '&:hover': {
                  borderColor: '#0EA5E9',
                  backgroundColor: 'rgba(14, 165, 233, 0.04)'
                }
              }} data-id="element-5078">
                    Download Sample File
                  </Button>
                  <Button variant="contained" startIcon={<Icon icon="lucide:upload" width={18} data-id="element-5081" />} onClick={() => setShowUploadCard(true)} sx={{
                background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)'
                }
              }} data-id="element-5080">
                    Upload Reversal File
                  </Button>
                </Box>
                <Box sx={{
              mt: 6,
              p: 3,
              backgroundColor: 'rgba(14, 165, 233, 0.04)',
              borderRadius: 2,
              border: '1px solid rgba(14, 165, 233, 0.1)',
              textAlign: 'left',
              maxWidth: 700,
              mx: 'auto'
            }} data-id="element-5082">
                  <Typography variant="subtitle2" gutterBottom fontWeight={600} color="primary.main" data-id="element-5083">
                    Required File Columns:
                  </Typography>
                  <Box component="ul" sx={{
                mt: 2,
                pl: 2
              }} data-id="element-5084">
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5085">
                      <strong data-id="element-5086">Original Txn Date:</strong> Date of the original
                      transaction (YYYY-MM-DD)
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5087">
                      <strong data-id="element-5088">Txn Rail:</strong> Transaction rail (1link, RAAST,
                      or RTGS)
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5089">
                      <strong data-id="element-5090">Partner:</strong> Name of the partner/MTO
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5091">
                      <strong data-id="element-5092">Txn Amount:</strong> Transaction amount (numeric)
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5093">
                      <strong data-id="element-5094">CBS Reference:</strong> CBS reference (optional)
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5095">
                      <strong data-id="element-5096">Txn Reference:</strong> STAN (6-digit for 1link),
                      MessageId (3-35 chars for RAAST), or uniqueId (for RTGS)
                    </Typography>
                    <Typography component="li" variant="body2" sx={{
                  mb: 1
                }} data-id="element-5097">
                      <strong data-id="element-5098">Receiver IBAN:</strong> IBAN of the receiver (PK +
                      22 digits)
                    </Typography>
                    <Typography component="li" variant="body2" data-id="element-5099">
                      <strong data-id="element-5100">Receiver Name:</strong> Name of the receiver
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{
              mt: 3,
              p: 2,
              backgroundColor: 'rgba(245, 158, 11, 0.04)',
              borderRadius: 2,
              border: '1px solid rgba(245, 158, 11, 0.1)',
              textAlign: 'left',
              maxWidth: 700,
              mx: 'auto'
            }} data-id="element-5101">
                  <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1
              }} data-id="element-5102">
                    <Icon icon="lucide:info" width={18} height={18} color="#F59E0B" style={{
                  marginTop: 2,
                  flexShrink: 0
                }} data-id="element-5103" />
                    <Box data-id="element-5104">
                      <Typography variant="subtitle2" gutterBottom fontWeight={600} color="#F59E0B" data-id="element-5105">
                        Sample File Contains Test Data
                      </Typography>
                      <Typography variant="body2" color="text.secondary" data-id="element-5106">
                        The sample file includes 7 demo transactions with
                        realistic data. You can use these to test the reversal
                        process or modify them with your actual transaction
                        details. The demo data follows all validation rules and
                        formats.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card> : <ReversalUploadCard onClose={() => setShowUploadCard(false)} data-id="element-5107" />}
        </Container>
      </Box>
    </Box>;
};
export default TransactionReversal;